import Jumbotron from './Jumbotron'

export default Jumbotron
// eslint-disable-next-line import/export
export * from './Jumbotron'
